import React from "react";
import dayjs from "dayjs";
import { Divider } from "antd";
import { PhoneOutlined } from "@ant-design/icons";
import { safeCall } from "../../../utils/webview"; // 添加这一行

export default ({ content = {}, style = {}} ) => { 
    console.log('=============>', content);
    const {
        times,
        usedTimes,
        startTime,
        endTime,
        latestUseTime,
        intervalTime,
        title,
        createTime,
        customer,
    } = content;

    return (
        <div style={{border: '1px solid rgb(240,240,240)', padding: '10px', borderRadius: '6px', ...style}}>
            <div style={{fontWeight: 'bold', borderBottom: '1px solid rgb(240,240,240)', paddingBottom: '10px', marginBottom: '10px'}}>
                次卡名称: {title}
            </div>
            <div>
                剩余次数: {times - usedTimes}/{times}
            </div>
            <div>
                客户: {customer?.username || ''}-{customer?.phoneNo || ''}{customer?.phoneNo && <a onClick={() => safeCall(customer.phoneNo)}> <PhoneOutlined /></a>}
            </div>
            <div>
                购买时间: {dayjs(createTime).format('YYYY-MM-DD HH:mm')}
            </div>
            <div style={{display: 'flex'}}>
                <span style={{ whiteSpace: 'nowrap'}}>有效期：</span>
                <span>{dayjs(startTime).format("YYYY-MM-DD HH:mm")} - {dayjs(endTime).format("YYYY-MM-DD HH:mm")}</span>
            </div>
            <div>
                上次使用时间：{latestUseTime ? dayjs(latestUseTime).format("YYYY-MM-DD HH:mm") : '未使用'}
            </div>
            <div>
                下次可用时间：{latestUseTime ? dayjs(latestUseTime).add(intervalTime, "day").format("YYYY-MM-DD HH:mm") + '以后' : '现在'}
            </div>
        </div>
    );
}